module.exports = __webpack_public_path__ + "static/media/VIh.69a389f5.png";